import './CategoryGamesGrid.scss';

import { useRef } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_LANGUAGE } from '../../i18n/constants';
import { getUserLanguage } from '../../i18n/helpers';
import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';

import { GameCard } from './GameCard';
import { useGamesSeen } from './hooks/useGamesSeen';
import GamesLoader from './Loader';
import MoreGames from './MoreGames';
import { seenGamesGridListener } from './seenGamesImpression';

export const CategoryGamesGrid = observer(() => {
  const { t, i18n } = useTranslation();
  const { categoriesStore } = useStores();
  const { currentCategory } = categoriesStore;
  const gameLabelFF = useFlag('game_labels_feat', true);

  const gamesGridRef = useRef<HTMLDivElement>(null);
  const subCategoryGames = currentCategory?.subCategoryGames || [];

  useGamesSeen(seenGamesGridListener);

  if (categoriesStore.loading.get('categories')) {
    return <GamesLoader />;
  }

  const language = getUserLanguage(i18n.language);
  const rowName = currentCategory?.name[language] || currentCategory?.name[DEFAULT_LANGUAGE] || 'unknown';
  const categoryPosition = categoriesStore.categoriesIds.indexOf(categoriesStore.currentId) + 1;

  return (
    <div ref={gamesGridRef} className="games-grid-wrapper">
      {!subCategoryGames.length && <div className="games-grid__text">{t('games.noGamesFound')}</div>}
      <div className="games-grid" data-category-position={categoryPosition} data-games-row={rowName}>
        {subCategoryGames.map((game, index) => (
          <GameCard
            key={`${game.masterCasinoGameId}_${index}`}
            game={game}
            gameLabelFF={gameLabelFF}
            rowName={rowName}
          />
        ))}
      </div>
      {categoriesStore.loading.get('pagination') ? <GamesLoader /> : currentCategory?.hasMoreGames && <MoreGames />}
    </div>
  );
});
